/** Background decorations — isolated in overflow:hidden so they never bleed out */
export function SectionDecor() {
  return (
    <div
      className="pointer-events-none absolute inset-0 overflow-hidden"
      aria-hidden="true"
    >
      {/* Corner geometric pattern */}
      <svg
        className="absolute right-0 top-0 h-full w-64 opacity-[0.035] max-lg:hidden"
        viewBox="0 0 256 600"
        preserveAspectRatio="xMidYMid slice"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {[60, 180, 300, 420, 540].map((y) => (
          <g key={y}>
            <rect
              x="78"
              y={y - 60}
              width="120"
              height="120"
              stroke="#FFB606"
              strokeWidth="0.8"
              transform={`rotate(0 128 ${y})`}
            />
            <rect
              x="78"
              y={y - 60}
              width="120"
              height="120"
              stroke="#FFB606"
              strokeWidth="0.8"
              transform={`rotate(45 128 ${y})`}
            />
            <circle cx="128" cy={y} r="30" stroke="#FFB606" strokeWidth="0.5" />
          </g>
        ))}
      </svg>

      {/* Soft golden radial at bottom */}
      <div
        className="absolute bottom-0 left-1/2 -translate-x-1/2 h-80 w-full"
        style={{
          background:
            'radial-gradient(60% 80% at 50% 100%, rgba(255,182,6,0.06) 0%, transparent 70%)',
        }}
      />
    </div>
  )
}
